

const campaignNameToAPName = (campaignName) => {
  const apName = `Aesthetic Point ${campaignName}`
  return apName
}

////////////////////////////////////////////////////////////

const campaignNameToServiceNumber = (campaignName) => {
    const servicesList = {
      'Hamburg Ottensen': 1,
      'Oldenburg': 2,
      'Ahaus': 3,
      'Augsburg': 4,
      'Bad Langensalza': 5,
      'Berlin Schöneberg': 6,
      'Bonn': 7,
      'Braunschweig': 8,
      'Dielheim': 9,
      'Hamburg Uhlenhorst': 10,
      'Herdecke': 11,
      'Köln Weiden': 12,
      'Leipzig Alt-West': 13,
      'Leipzig Nord': 14,
      'Malchin': 15,
      'Mansfeld': 16,
      'Oberderdingen': 17,
      'Reutlingen': 18,
      'Saarbrücken': 19,
      'Straubing': 20,
      'Trier': 21,
    };
  return servicesList[campaignName]
}

/////////////////////////////////////////////////////////////////////

const getIsPhysioPage = () => {
  const path = window.location.pathname;
  if(path.includes('physio')){
    return true
  }
  return false
}

/////////////////////////////////////////////////////////////////////

const formatStringToURLPath = (str) => {
  str = str.replace(/\.$/, '');
  const umlautMap = {
      'ä': 'ae', 'ö': 'oe', 'ü': 'ue', 'ß': 'ss',
      'Ä': 'ae', 'Ö': 'oe', 'Ü': 'ue'
  };
  let formattedStr = str.trim().replace(/[äöüÄÖÜß]/g, match => umlautMap[match]);
    
  // Ersetze Leerzeichen mit Bindestrichen und wandle in lowercase um
  formattedStr = formattedStr.replace(/\s+/g, '-').toLowerCase();
  return formattedStr;
}


const formatPhysioCategoryToShopifyPath = (category) => {  
  switch (category) {
    case "Wirbelsäule & Nacken (inkl. Kopf/CMD)":
      return 'physio-wirbelsaeule-und-nacken'
      break;
    case "Schulter, Arm & Hand":
      return 'physio-schulter-arm-und-hand'
      break;
    case "Hüfte, Knie, Fuß & Gang":
      return 'physio-huefte-knie-fuss-und-gang'
      break;
    case "Sport & Recovery":
      return 'physio-sport-und-recovery'
      break;
    case "Gleichgewicht & Schwindel (vestibulär)":
      return 'physio-gleichgewicht-und-schwindel'
      break;
    case "Manuelle & myofasziale Techniken":
      return 'physio-manuelle-und-myofasziale-techniken'
      break;
    case "Haltung, Core & Beckenboden": 
      return 'physio-haltung-core-und-beckenboden'
      break;
    case "Viszerale Arbeit, Atmung & Craniosakral": 
      return 'physio-viszerale-arbeit-atmung-und-craniosakral'
      break;
    case "Rehabilitation, Narben & Schwellung": 
      return 'physio-rehabilitation-narben-und-schwellung'
      break;
    case "Schwangerschaft, Baby & Kind": 
      return 'physio-schwangerschaft-baby-und-kind'
      break;
    default:
      return ''
  }
}
const formatCategoryPathToPhysioCategory = (path) => {  
  switch (path) {
    case '/products/physio-wirbelsaeule-und-nacken':
      return "Wirbelsäule & Nacken (inkl. Kopf/CMD)"
      break;
    case '':
      return "Schulter, Arm & Hand"
      break;
    case '':
      return "Hüfte, Knie, Fuß & Gang"
      break;
    case "":
      return 'Sport & Recovery'
      break;
    case "":
      return 'Gleichgewicht & Schwindel (vestibulär)'
      break;
    case "":
      return 'Manuelle & myofasziale Techniken'
      break;
    case "": 
      return 'Haltung, Core & Beckenboden'
      break;
    case "": 
      return 'Viszerale Arbeit, Atmung & Craniosakral'
      break;
    case "": 
      return 'Rehabilitation, Narben & Schwellung'
      break;
    case "": 
      return 'Schwangerschaft, Baby & Kind'
      break;
    default:
      return ''
  }
}
